module.exports = __webpack_public_path__ + "img/ic_bullet-list.5134319d.svg";